module.exports = __webpack_public_path__ + "media/Images/icon-user-graph-o-679a8a033aa34f3d70e5dd1cccecaaae.svg";